import { useDispatch, useSelector } from 'react-redux';
import { useCreateGdsServicesRefundMutation } from '@websky/graphql';
import { ExchangeRefundCustomer } from '@entities/order';
import {
	getRefundServicesSelectedProductIds,
	REFUND_SERVICES_ROUTES,
	useShowRefundServicesErrorModal
} from '@entities/refund-services';
import { useRouter } from '@shared/router';

import { getOrderId } from '../../../../../Checkout/store/order/selectors';
import { setLastGdsServicesRefund } from '../../../../../Checkout/store/order/actions';

export const useCreateRefundServices = () => {
	const dispatch = useDispatch();
	const router = useRouter();
	const showErrorModal = useShowRefundServicesErrorModal();

	const orderId = useSelector(getOrderId);
	const selectedProductIds = useSelector(getRefundServicesSelectedProductIds);

	const [createServicesRefund, { loading: isLoading }] = useCreateGdsServicesRefundMutation();

	const onCreateRefundServices = async (customer: ExchangeRefundCustomer) => {
		try {
			const { data, errors } = await createServicesRefund({
				variables: {
					params: {
						orderId,
						productIds: selectedProductIds,
						...customer
					}
				}
			});

			if (errors?.length) {
				showErrorModal(errors);

				return;
			}

			if (data?.CreateGdsServicesRefund) {
				dispatch(setLastGdsServicesRefund(data?.CreateGdsServicesRefund));
				router.navigate(REFUND_SERVICES_ROUTES.REQUEST);
			}
		} catch (error) {
			showErrorModal(error);
		}
	};

	return {
		onCreateRefundServices,
		isLoading
	};
};
